import script from "./MainMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=ce55114c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce55114c"]])

export default __exports__